var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#4079F5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7013 16.2103C19.0726 16.2103 19.375 16.4935 19.375 16.8353V18.0854H0.624817V16.8353C0.624817 16.4935 0.927417 16.2103 1.29852 16.2103H1.8749V15.6332C1.8749 15.2914 2.17751 15.0081 2.54861 15.0081L3.12499 15.0084V7.5395H2.54861C2.17727 7.5395 1.8749 7.25627 1.8749 6.91445H0.624817V5.66437L10 1.91434L19.3752 5.66437V6.91445H18.1251C18.1251 7.25627 17.8225 7.5395 17.4514 7.5395H16.875V15.0084H17.4514C17.8227 15.0084 18.1251 15.2916 18.1251 15.6334V16.2103H18.7013ZM5.62493 7.5395V15.0084H6.87502V7.5395H5.62493ZM9.37496 7.5395V15.0084H10.6251V7.5395H9.37496ZM13.125 7.5395V15.0084H14.3751V7.5395H13.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAch);
export default __webpack_public_path__ + "static/media/ACH.9f13ba7781199d7fc524b304eac824e0.svg";
export { ForwardRef as ReactComponent };